/**
 * Authors: mariushirjanu
 * Created: 24/02/2021
 */
import { Injectable } from '@angular/core';

import { HttpDataService, IHttpDataCache } from '../../http/http-data.service';
import { ICodeValue } from '../../../../type_definitions/datatypes';
import * as _ from 'underscore';
import { IReportAction } from '../../report/report-data.service';

@Injectable()
export class WorkflowDataService {
  private cache:IHttpDataCache<any>;
  public static TYPE_PO:string = 'PO';
  public static TYPE_PQ:string = 'PQ';

  constructor(
    private httpDataService:HttpDataService
  ) {
    this.cache = httpDataService.createCache();
  }

  public clear():void {
    this.cache.clear();
  }

  public getCCClearingStatuses():Promise<ICodeValue[]> {
    return this.cache.doGET(
      `rest/workflow/ccclearingstatuses`,
      {},
      undefined,
      'Error loading statuses'
    );
  }

  public loadWorkflowStatuses(type:string):Promise<any> {
    return this.cache.doGET(
      'rest/workflow/workflowstatuses', { type }, undefined, 'Error loading workflow statuses');
  }

  public loadWorkflowStepDefinitions(type:string, status:string):Promise<any> {
    return this.cache.doGET(
      'rest/workflow/stepdefinitions', {
        type,
        status
      }, undefined, 'Error loading workflow step definitions');
  }

  public isQuoteRow(row:any, actionMapping):boolean {
    const columnKey:string = (actionMapping?.Dereqid_ds)? actionMapping.Dereqid_ds : 'Dereqid_ds';
    return (row[columnKey] === WorkflowDataService.TYPE_PQ
      || (_.isString(row[columnKey]) && row[columnKey]?.toLowerCase() === 'quote')
      || row[columnKey]?.properties?.type === WorkflowDataService.TYPE_PQ
      || (_.isString(row[columnKey]?.properties?.type) && row[columnKey]?.properties?.type?.toLowerCase() === 'quote'));
  }

  public isOrderRow(row:any, actionMapping):boolean {
    const columnKey:string = (actionMapping?.Dereqid_ds)? actionMapping.Dereqid_ds : 'Dereqid_ds';
    return (row[columnKey] === WorkflowDataService.TYPE_PO
      || (_.isString(row[columnKey]) && row[columnKey]?.toLowerCase() === 'order')
      || row[columnKey]?.properties?.type === WorkflowDataService.TYPE_PO
      || (_.isString(row[columnKey]?.properties?.type) && row[columnKey]?.properties?.type?.toLowerCase() === 'order'));
  }

  // returns PO or PQ (fallback: PO)
  public getWorkflowType(rowSelection:any, action:IReportAction):string {
    // test if the selected row is PQ
    const quote = _.find(rowSelection, (row:any) => this.isQuoteRow(row, action.mapping));

    if (quote) {
      return WorkflowDataService.TYPE_PQ;
    }

    return WorkflowDataService.TYPE_PO;
  }
}